import { Path } from '../router/Routes';

export const isBoardPath = (path: Path): boolean =>
  path === Path.BOARD_LIST || path === Path.BOARD_DETAILS || path === Path.BOARD_MESSAGE || path === Path.BOARD_THREAD;
